import React from 'react';
import { Wrench, Clock, HardHat } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import ProduccionLayout from '@/components/ProduccionLayout';

export default function Mantenimiento({ user, onLogout }) {
  return (
    <ProduccionLayout user={user} onLogout={onLogout}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card className="border-dashed border-2 border-gray-300 dark:border-gray-600">
          <CardContent className="flex flex-col items-center justify-center py-16 px-8 text-center">
            <div className="relative mb-6">
              <div className="w-24 h-24 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
                <Wrench className="w-12 h-12 text-amber-600 dark:text-amber-400" />
              </div>
              <div className="absolute -top-1 -right-1 w-8 h-8 bg-emerald-100 dark:bg-emerald-900/30 rounded-full flex items-center justify-center">
                <Clock className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
              </div>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-3">
              Módulo de Mantenimiento
            </h2>
            
            <p className="text-lg text-amber-600 dark:text-amber-400 font-semibold mb-4 flex items-center">
              <HardHat className="w-5 h-5 mr-2" />
              Pronto estará lista
            </p>
            
            <p className="text-gray-600 dark:text-gray-400 max-w-md mb-6">
              Estamos trabajando en el módulo de mantenimiento para gestionar el mantenimiento preventivo y correctivo de la producción.
            </p>
            
            <div className="flex flex-wrap gap-3 justify-center">
              <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full text-sm">
                Mantenimiento Preventivo
              </span>
              <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full text-sm">
                Órdenes de Trabajo
              </span>
              <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full text-sm">
                Historial de Reparaciones
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </ProduccionLayout>
  );
}
